import { format, setMonth } from "date-fns";
import * as locales from "date-fns/locale";
import type { CalendarLocaleType } from "./types";

const defaultLocale = "enUS";

export function formatDate(
  date: Date,
  formatStr: string,
  locale: CalendarLocaleType = defaultLocale
) {
  const localeObj = locales[locale] || locales[defaultLocale];

  return format(date, formatStr, {
    locale: localeObj,
  });
}

export function getMonthInLocale(
  month: number,
  locale: CalendarLocaleType = defaultLocale
) {
  return formatDate(setMonth(new Date(), month), "LLLL", locale);
}
